import { App } from 'vue'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'

export default {
  install: (app: App<Element>) => {
    app.component('Multiselect', Multiselect)
  }
}
